import { BUSINESS_SECTION_TYPE_MLE, mleFields, PREFIX_KYCURLS } from "components/Onboarding/Mle/BusinessTab/contants";
import { GST } from "components/Onboarding/Mle/mle.constants";
import { mapCheckerRemarksKeyWithNames } from "components/Onboarding/Mle/mle.utils";
import { mutateMleDataMerchant } from "containers/MerchantLegalEntity/merchantLegalEntity.utils";

export const MAKER_BASE_URL = '/maker/';

const convertCheckerRemarks = checkerRemarks => {
    let updatedRemark = {};
    checkerRemarks.map(item => {
        if (item.key === `${PREFIX_KYCURLS}.${GST}`) {
            updatedRemark[mleFields.gstUpload.reqName] = {
                ...item
            }
        } else {
            updatedRemark[item.key] = {
                ...item,
            };
        }
    });

    return updatedRemark;
};

export const getMakerData = (data, sectionType, basicSectionData) => {
    
    let requestedData = {};
    let formIdentityData = {};
    let draftData = {};
    let checkerRemarks = {};
    let isViewMode = true;
    if (typeof data?.childCheckerResponseList === 'object') {
        data.childCheckerResponseList.map(makerCheckerResponse => {
            if (makerCheckerResponse) {
                if (
                    sectionType === makerCheckerResponse.eventType.toLowerCase() 
                    && makerCheckerResponse?.request && makerCheckerResponse?.message
                ) {
                    requestedData = JSON.parse(
                        makerCheckerResponse.request
                    );
                    formIdentityData = JSON.parse(
                        makerCheckerResponse.message
                    )
                    draftData = { ...mutateMleDataMerchant({...requestedData.data || requestedData}, sectionType) };
                    checkerRemarks = makerCheckerResponse?.checkerRemarks?.[0] || [];
                                    
                    isViewMode = makerCheckerResponse?.userActionStatus !== 'PENDING'
                }
            }
        });
    }
    let updatedRemark = {};
    if (checkerRemarks?.length) {
        updatedRemark = convertCheckerRemarks(checkerRemarks);
        if (basicSectionData?.mleUpdateConfig) {
            Object.entries(basicSectionData?.mleUpdateConfig).map(([key, value]) => {  
                if (updatedRemark[mapCheckerRemarksKeyWithNames(key)])
                    if (mapCheckerRemarksKeyWithNames[key] === 'gstUpload') {
                        updatedRemark["kycDocUrls.GST"] = value?.docCategory || [];
                    } else {
                        updatedRemark[mapCheckerRemarksKeyWithNames(key)].docCategory = value?.docCategory || [];
                    }
            })
        }
    }
    
    
    
    

    return { draftData, checkerRemarks: updatedRemark, formIdentityData, isViewMode };
};
